import ProductCard from "@/store/components/ProductCard";
import type { Coupon, Product } from "@/store/types";

interface ProductGridProps {
  products: Product[];
  purchasedCodes: Set<string>;
  isMember: boolean;
  coupons: Coupon[];
  busy: boolean;
  processingCode: string | null;
  onPurchase: (product: Product) => void;
  onAddToCart: (product: Product) => void;
  onViewDetails: (product: Product) => void;
}

export default function ProductGrid({
  products,
  purchasedCodes,
  isMember,
  coupons,
  busy,
  processingCode,
  onPurchase,
  onAddToCart,
  onViewDetails,
}: ProductGridProps) {
  if (products.length === 0) {
    return (
      <div className="agd:py-10 agd:text-center agd:text-[0.95rem] agd:text-muted-foreground">
        No products match your search.
      </div>
    );
  }

  return (
    <div
      className="agd:grid agd:gap-5"
      style={{ gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 300px), 1fr))" }}
    >
      {products.map((product) => (
        <ProductCard
          key={product.ProductCode}
          product={product}
          isPurchased={purchasedCodes.has(product.ProductCode)}
          isMember={isMember}
          coupons={coupons}
          busy={busy}
          processingCode={processingCode}
          onPurchase={onPurchase}
          onAddToCart={onAddToCart}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
}
